import {
    ButtonContext,
    ButtonProps,
    LinkContext,
    LinkProps,
} from "react-aria-components";

/**
 * Builds the `values` array for a react-aria `<Provider>` that sets a default
 * `data-click-type` on every descendant Button and Link.
 *
 * react-aria's `ButtonProps`/`LinkProps` don't expose a `data-*` index
 * signature, so an `as unknown as` cast is required. Centralising it here
 * keeps the cast in one place — if react-aria ever permits passthrough
 * `data-*` props, this is the single file to update.
 */
type ContextEntries = [
    [typeof ButtonContext, ButtonProps],
    [typeof LinkContext, LinkProps],
];

export const clickTrackingValues = (clickType: string): ContextEntries => [
    [ButtonContext, { "data-click-type": clickType } as unknown as ButtonProps],
    [LinkContext, { "data-click-type": clickType } as unknown as LinkProps],
];
